import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './dashboard/sidebar/sidebar.component';
import { ToggleDirective } from './dashboard/sidebar/toggle.directive';
import { HomeComponent } from './page/home/home.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
///////componentes add posteriormente
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { MatChipsModule } from '@angular/material/chips';
import { MatGridListModule } from '@angular/material/grid-list';
import { NgxMaskModule } from 'ngx-mask';
import { ProductFormComponent } from './page/product/product-form.component';
import { ProductConsultaComponent } from './page/product/product-consulta.component';
import { SaleDialogComponent } from './page/sale-dialog/sale-dialog.component';
import { SaleComponent } from './page/sale/sale.component';
import { SalesListComponent } from './page/sales-list/sales-list.component';
import { PaymentService } from './service/payment.service';
import { ProductService } from './service/product.service';
import { ConfirmaDeleteComponent } from './util/confirma-delete/confirma-delete.component';
import { SaleService } from './service/sale.service';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { LoginService } from './service/login.service';
import { LoginComponent } from './page/login/login.component';
import { HttpInterceptorModule } from './service/headerInterceptor.service';
import { ClientFormComponent } from './page/client/client-form.component';
import { ClientConsultaComponent } from './page/client/client-consulta.component';
import { FornecedorComponent } from './page/fornecedor/fornecedor.component';
import { FornecedorFormComponent } from './page/fornecedor/fornecedor-form.component';
import { FornecedorConsultaComponent } from './page/fornecedor/fornecedor-consulta.component';
import { EstoqueComponent } from './page/estoque/estoque.component';
import { EstoqueFormComponent } from './page/estoque/estoque-form.component';
import { EstoqueConsultaComponent } from './page/estoque/estoque-consulta.component';
import { RelatorioComponent } from './page/relatorio/relatorio.component';
import { RelatoriosComponent } from './page/relatorios/relatorios.component';
import { BoxComponent } from './page/box/box.component';
import { BoxConsultaComponent } from './page/box/box-consulta.component';
import { BoxFormComponent } from './page/box/box-form.component';
import { SaleDialogImprimirComponent } from './page/sale-dialog-imprimir/sale-dialog-imprimir.component';
import { ContaPagarFormComponent } from './page/conta-pagar/conta-pagar-form.component';
import { ContaPagarConsultaComponent } from './page/conta-pagar/conta-pagar-consulta.component';
import { ContaReceberFormComponent } from './page/conta-receber/conta-receber-form.component';
import { ContaReceberConsultaComponent } from './page/conta-receber/conta-receber-consulta.component';
import { ComodatoFormComponent } from './page/comodato/comodato-form.component';
import { ComodatoConsultaComponent } from './page/comodato/comodato-consulta.component';
import { NeighborhoodComponent } from './page/neighborhood/neighborhood.component';
import { NeighborhoodConsultaComponent } from './page/neighborhood/neighborhood-consulta.component';
import { NeighborhoodFormComponent } from './page/neighborhood/neighborhood-form.component';
import { AreceberDialogDetalheComponent } from './page/areceber-dialog-detalhe/areceber-dialog-detalhe.component';
import { AreceberDialogPagamentoComponent } from './page/areceber-dialog-pagamento/areceber-dialog-pagamento.component';
import { NotaFiscalDialogComponent } from './page/nota-fiscal-dialog/nota-fiscal-dialog.component';
import { DiologHistoricoClienteComponent } from './page/diolog-historico-cliente/diolog-historico-cliente.component';
import { MovimentacaoComponent } from './page/movimentacao/movimentacao.component';
import { MovimentacaoFormComponent } from './page/movimentacao/movimentacao-form.component';
import { MovimentacaoConsultaComponent } from './page/movimentacao/movimentacao-consulta.component';
import { EmpresaComponent } from './page/empresa/empresa.component';
import { PlanoFormComponent } from './page/plano/plano-form.component';
import { PlanoConsultaComponent } from './page/plano/plano-consulta.component';
import { UsuarioComponent } from './page/usuario/usuario.component';
import { UsuarioConsultaComponent } from './page/usuario/usuario-consulta.component';
import { UsuarioFormComponent } from './page/usuario/usuario-form.component';
import { FuncionarioComponent } from './page/funcionario/funcionario.component';
import { CidadeComponent } from './page/cidade/cidade.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { TicketFormComponent } from './page/ticket/ticket-form.component';
import { TicketConsultaComponent } from './page/ticket/ticket-consulta.component';
import { TicketKanbanComponent } from './page/ticket/ticket-kanban.component';
import { SegmentoFormComponent } from './page/segmento/segmento-form.component';
import { SegmentoConsultaComponent } from './page/segmento/segmento-consulta.component';
import { DepartamentoFormComponent } from './page/departamento/departamento-form.component';
import { DepartamentoConsultaComponent } from './page/departamento/departamento-consulta.component';
import { CargoFormComponent } from './page/cargo/cargo-form.component';
import { CargoConsultaComponent } from './page/cargo/cargo-consulta.component';
import { ColaboradorFormComponent } from './page/colaborador/colaborador-form.component';
import { ColaboradorConsultaComponent } from './page/colaborador/colaborador-consulta.component';
import { ContaReceberLoteComponent } from './page/conta-receber-lote/conta-receber-lote.component';
import { TicketCadastroComponent } from './util/ticket/ticket-cadastro.component';
import { TicketComentariosComponent } from './util/ticket/ticket-comentarios.component';
import { PerfilComponent } from './page/perfil/perfil.component';
import { PerfilFormComponent } from './page/perfil/perfil-form.component';
import { PerfilConsultaComponent } from './page/perfil/perfil-consulta.component';
import { BannerFormComponent } from './page/banner/banner-form.component';
import { BannerConsultaComponent } from './page/banner/banner-consulta.component';
import { EnderecoCadastroComponent } from './util/endereco/endereco-cadastro.component';
import { BannerCadastroComponent } from './util/banner/banner-cadastro.component';
import { PlanoCadastroComponent } from './util/plano/plano-cadastro.component';
import { ComodatoCadastroComponent } from './util/comodato/comodato-cadastro.component';
import { FornecedorCadastroComponent } from './util/fornecedor/fornecedor-cadastro.component';
import { ProductCadastroComponent } from './util/product/product-cadastro.component';
import { WowConsultaFiltrosComponent } from './util/consulta/wow-consulta-filtros.component';
import { ContaFinanceiraCadastroComponent } from './util/conta-financeira/conta-financeira-cadastro.component';
import { AnexoVisualizarDialogComponent } from './util/conta-financeira/anexo-visualizar-dialog.component';
import { ContaCorrenteFormComponent } from './page/conta-corrente/conta-corrente-form.component';
import { ContaCorrenteConsultaComponent } from './page/conta-corrente/conta-corrente-consulta.component';
import { FuncionalidadeFormComponent } from './page/funcionalidade/funcionalidade-form.component';
import { FuncionalidadeConsultaComponent } from './page/funcionalidade/funcionalidade-consulta.component';
import { RichTextEditorComponent } from './util/rich-text-editor/rich-text-editor.component';
import { RichTextContentComponent } from './util/rich-text-editor/rich-text-content.component';

registerLocaleData(localePt, 'pt-BR');

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    ToggleDirective,
    HomeComponent,
    ConfirmaDeleteComponent,
    ProductFormComponent,
    ProductConsultaComponent,
    ProductCadastroComponent,
    SaleComponent,
    SaleDialogComponent,
    SalesListComponent,
    LoginComponent,
    ClientFormComponent,
    ClientConsultaComponent,
    WowConsultaFiltrosComponent,
    FornecedorComponent,
    FornecedorFormComponent,
    FornecedorConsultaComponent,
    FornecedorCadastroComponent,
    EnderecoCadastroComponent,
    EstoqueComponent,
    EstoqueFormComponent,
    EstoqueConsultaComponent,
    RelatorioComponent,
    RelatoriosComponent,
    BoxComponent,
    BoxConsultaComponent,
    BoxFormComponent,
    SaleDialogImprimirComponent,
    ContaPagarFormComponent,
    ContaPagarConsultaComponent,
    ContaReceberFormComponent,
    ContaReceberConsultaComponent,
    ContaFinanceiraCadastroComponent,
    AnexoVisualizarDialogComponent,
    ContaCorrenteFormComponent,
    ContaCorrenteConsultaComponent,
    ComodatoConsultaComponent,
    ComodatoFormComponent,
    ComodatoCadastroComponent,
    NeighborhoodComponent,
    NeighborhoodConsultaComponent,
    NeighborhoodFormComponent,
    AreceberDialogDetalheComponent,
    AreceberDialogPagamentoComponent,
    NotaFiscalDialogComponent,
    DiologHistoricoClienteComponent,
    MovimentacaoComponent,
    MovimentacaoFormComponent,
    MovimentacaoConsultaComponent,
    EmpresaComponent,
    PlanoConsultaComponent,
    PlanoFormComponent,
    PlanoCadastroComponent,
    FuncionalidadeConsultaComponent,
    FuncionalidadeFormComponent,
    UsuarioComponent,
    UsuarioConsultaComponent,
    UsuarioFormComponent,
    FuncionarioComponent,
    CidadeComponent,
    TicketConsultaComponent,
    TicketKanbanComponent,
    TicketFormComponent,
    TicketCadastroComponent,
    TicketComentariosComponent,
    RichTextEditorComponent,
    RichTextContentComponent,
    SegmentoConsultaComponent,
    SegmentoFormComponent,
    DepartamentoConsultaComponent,
    DepartamentoFormComponent,
    CargoConsultaComponent,
    CargoFormComponent,
    ColaboradorConsultaComponent,
    ColaboradorFormComponent,
    ContaReceberLoteComponent,
    PerfilComponent,
    PerfilFormComponent,
    PerfilConsultaComponent,
    BannerConsultaComponent,
    BannerFormComponent,
    BannerCadastroComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatNativeDateModule,
    MatRadioModule,
    MatTooltipModule,
    MatRippleModule,
    MatDividerModule,
    MatToolbarModule,
    MatGridListModule,
    MatTabsModule, 
    FormsModule,
    CurrencyMaskModule,
    HttpInterceptorModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSnackBarModule,
    MatSelectModule,
    MatBadgeModule,
    MatChipsModule,
    CommonModule,
    MatListModule,
    DragDropModule,
    NgxMaskModule.forRoot(
      { // não salvar a mascara
        dropSpecialCharacters: false
      }
    ),
    MatAutocompleteModule
  ],
  providers: [
    ProductService,
    PaymentService,
    SaleService,
    LoginService,
    //informar formato da data local
    { provide: LOCALE_ID, useValue: 'pt-BR' }
    // { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    // {
    //   provide: LOCALE_ID,
    //   useValue: 'pt'
    // },

    // /* if you don't provide the currency symbol in the pipe, 
    // this is going to be the default symbol (R$) ... */
    // {
    //   provide: DEFAULT_CURRENCY_CODE,
    //   useValue: 'BRL'
    // }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}
